import React, { useEffect, useGlobal } from "reactn";
import PropTypes from "prop-types";
import { useRouteMatch } from "react-router-dom";
import { TabsWrapper, Tab } from "./Tabs.styled";
import { TabMenuStyled } from "./TabMenu.styled";

// hooks
import profileHooks from "../../../hooks/profileHooks";
import AppHook from "../../../hooks/appHook";
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

const TabMenu = ({ tabMenuItems, history, isBusiness }) => {
    const match = useRouteMatch();
    const { activeTab, setActiveTab } = profileHooks();
    const { removeNavMargins, handleMainMargin } = AppHook();

    // get global index to set when tab is clicked so the dropdown menu is synced
    const [submenuIndex, setSubmenuIndex] = useGlobal("submenuIndex");
    const [isCollapsed] = useGlobal("isCollapsed");
    const { isMobile } = DetectDeviceResize();

    const setCurrentTab = tab => {
        setActiveTab(tab);
    };

    const onClick = (e, key, i) => {
        e.preventDefault();
        setCurrentTab(key);
        setSubmenuIndex(i);
        if (key.toLowerCase() !== "my-deliveries") {
            history.push(`/${key}`);
        } else {
            isBusiness ? history.push("/Business") : history.replace("/");
        }
    };

    useEffect(() => {
        if (isMobile) {
            removeNavMargins();
        } else {
            handleMainMargin(isCollapsed);
        }
    }, [isMobile, isCollapsed]);


    return (
        <TabMenuStyled>
            <TabsWrapper>
                {
                    tabMenuItems.map((tabItem, i) => (
                        <Tab hasNotification={tabItem.notification} key={tabItem.key} active={activeTab === tabItem.key.toLowerCase()} onClick={e => onClick(e, tabItem.key, i)} className="gtm-tab">
                            {tabItem.notification && <span className="notificationDot"></span>}
                            <h2>{tabItem.label}</h2>
                        </Tab>
                    ))}
            </TabsWrapper>
        </TabMenuStyled>
    );
};

export default TabMenu;

TabMenu.propTypes = {
    tabMenuItems: PropTypes.array,
    history: PropTypes.object,
    isBusiness: PropTypes.bool
};
